export default __webpack_public_path__ + "static/media/avatar-3.09dad8ca.png";